/* PF1 papel fixes 10/16 (block 311 in kd-custom-38.css). Jewelry Care page, desktop only (1024px and up).
   KD 10/16: the top papel sits mostly over the white side of the hero instead of centred across the page,
   keeping its full thickness at the LEFT end, from the page edge, and tapering just past the teal panel.
   Same drawing as CT2 (13.8px strip, 29.5px half moons, holes cut out), only placed and curved differently.
   The shape goes into --kd-pf1-mask on the care papel; kd-custom-38.css uses it from 1024px. Under 1024px
   nothing changes. (The Morse Code Key page had the mirror of this until KD's 1:57pm "just rid of papel on
   key page"; its desktop papel is now hidden in kd-custom-38.css, so it has no job here.)
   Home page, 768px and up (10/16 1:51pm, KD: "top to curve in slightly at left so thicker at right and opposite
   on bottom", subtly): the two centred TP1 papels keep their size, width and end tuck, but the curve is uneven:
   the green one under the logo bends up sooner on the left (power 1.5) and stays full longer on the right
   (power 3); the pink one under the reviews strip the other way round. Phones keep their swags.
   Built by Opilio Claudio. */
(function () {
  var JOBS = [
    { el: '#kdc-papel', box: '.kdc-hero', panel: '.kdc-hero-panel', from: 0, to: 1.06, cL: 0, cR: 0.83, anchor: 'left', min: 1024, band: 13.8, moon: 29.5 },
    { el: '#MainContent .shopify-section[id$="__section_text_tbKkVC"]', width: 58, cL: 0.83, cR: 0.83, pL: 1.5, pR: 3, anchor: 'center', min: 768, band: 13.8, moon: 29.5 },
    { el: '#MainContent .shopify-section[id$="__section_columns_rzanKM"]', width: 83, cL: 0.78, cR: 0.78, pL: 3, pR: 1.5, anchor: 'center', min: 768, band: 6, moon: 21.5 }
  ];
  function f(n) { return n.toFixed(2); }
  function shape(W, x0, x1, cL, cR, A, pL, pR, BAND, MOON) {
    var depth = MOON * 8 / 25.882, H = BAND + depth, hw = (x1 - x0) / 2, mid = x0 + hw;
    var R = MOON * MOON / (8 * depth) + depth / 2, dotR = depth * 2.3 / 8, dotY = depth * 3.5 / 8;
    var lift = function (x) { var u = hw ? (x - mid) / hw : 0; return u < 0 ? cL * H * 1.15 * Math.pow(-u, pL) : cR * H * 1.15 * Math.pow(u, pR); };
    var base = function (x) { return BAND - lift(x); };
    var first = A - Math.ceil(A / MOON) * MOON;
    var d = 'M' + f(x0) + ' ' + f(Math.min(0, base(x0))) + 'H' + f(x1) + 'V' + f(base(x1));
    var tiles = [];
    for (var a = first; a < W; a += MOON) tiles.push(a);
    var holes = '';
    for (var i = tiles.length - 1; i >= 0; i--) {
      var ta = tiles[i], tb = ta + MOON;
      d += 'L' + f(tb) + ' ' + f(base(tb)) + 'A' + R.toFixed(3) + ' ' + R.toFixed(3) + ' 0 0 1 ' + f(ta) + ' ' + f(base(ta));
      var cx = ta + MOON / 2, cy = base(cx) + dotY;
      if (cx > x0 && cx < x1 && cy - dotR > 0) holes += 'M' + f(cx - dotR) + ' ' + f(cy) + 'a' + f(dotR) + ' ' + f(dotR) + ' 0 1 0 ' + f(2 * dotR) + ' 0a' + f(dotR) + ' ' + f(dotR) + ' 0 1 0 ' + f(-2 * dotR) + ' 0Z';
    }
    d += 'L' + f(x0) + ' ' + f(base(x0)) + 'Z';
    return "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 " + W + " " + H.toFixed(3) + "' width='" + W + "' height='" + H.toFixed(3) + "' preserveAspectRatio='none'><defs><clipPath id='k'><rect x='" + f(x0) + "' y='0' width='" + f(x1 - x0) + "' height='" + H + "'/></clipPath></defs><path clip-path='url(#k)' fill-rule='evenodd' d='" + d + holes + "'/></svg>";
  }
  function paint() {
    for (var j = 0; j < JOBS.length; j++) {
      var job = JOBS[j], el = document.querySelector(job.el);
      if (!el) continue;
      if (!window.matchMedia('(min-width: ' + job.min + 'px)').matches) { el.style.removeProperty('--kd-pf1-mask'); continue; }
      var box = job.box ? el.closest(job.box) : el;
      if (!box) continue;
      var r = box.getBoundingClientRect(), W = Math.round(r.width), x0, x1;
      if (!W) continue;
      if (job.panel) {
        var panel = box.querySelector(job.panel), B = panel ? panel.getBoundingClientRect().left - r.left : 0;
        if (B <= 0) continue;
        x0 = Math.max(0, B * job.from); x1 = Math.min(W, B * job.to);
      } else {
        x0 = (W - W * job.width / 100) / 2; x1 = W - x0;
      }
      var A = job.anchor === 'right' ? x1 : job.anchor === 'left' ? x0 : W / 2 - job.moon / 2;
      el.style.setProperty('--kd-pf1-mask', 'url("data:image/svg+xml,' + encodeURIComponent(shape(W, x0, x1, job.cL, job.cR, A, job.pL || 2, job.pR || 2, job.band, job.moon)) + '")');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
  window.addEventListener('load', paint);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(paint, 150); });
})();